import { render, staticRenderFns } from "./PortalSidebar.vue?vue&type=template&id=0ea0b657&scoped=true"
import script from "./PortalSidebar.vue?vue&type=script&lang=js"
export * from "./PortalSidebar.vue?vue&type=script&lang=js"
import style0 from "./PortalSidebar.vue?vue&type=style&index=0&id=0ea0b657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0b657",
  null
  
)

export default component.exports